/**
 * @fileoverview Settings page route configuration
 * Displays the user account settings and preferences interface
 */

// Library imports
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { AppErrorBoundary } from "@/components/shared/app-error-boundary";

/**
 * Settings shell. Deliberately headerless: every settings child page renders its own
 * title, and the old shell header showed operator jargon ("Administration / manage
 * internal operator roles") to client users while double-stacking headings.
 */
function SettingsLayout() {
  return (
    <section className="flex w-full flex-col px-0">
      <Outlet />
    </section>
  );
}

/**
 * Route configuration for the settings section
 * Includes error handling and component rendering
 */
export const Route = createFileRoute("/(app)/dashboard/settings")({
  component: SettingsLayout,
  errorComponent: AppErrorBoundary,
});
